import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';

import { ApiService } from '../../services/api.service';
import { Global } from '../../global';
import { Router } from '@angular/router';

@Component({
  selector: 'app-consulta-ponto',
  templateUrl: './consulta-ponto.component.html',
  styleUrls: ['./consulta-ponto.component.css']
})
export class ConsultaPontoComponent implements OnInit {

  @ViewChild('abrirModalPontoFuncionario') public abrirModalPontoFuncionario: ElementRef;

  loading: boolean = false;
  filtro: any = {};
  data: Date = new Date();
  listaPontos: any = [];
  ponto: any = {};

  constructor(
    private apiService: ApiService,
    public global: Global,
    private router: Router
  ) { }

  ngOnInit() {
    this.filtro.mes = 1;
    this.filtro.ano = this.data.getFullYear();
    this.obterPontos();
  }

  voltarMes() {
    if (this.filtro.mes == 1) {
      this.filtro.mes = 12;
      this.filtro.ano = this.filtro.ano - 1;
    } else
      this.filtro.mes = this.filtro.mes - 1;
    this.obterPontos();
  }

  avancarMes() {
    if (this.filtro.mes == 12) {
      this.filtro.mes = 1;
      this.filtro.ano = this.filtro.ano + 1;
    } else
      this.filtro.mes = this.filtro.mes + 1;
    this.obterPontos();
  }

  obterPontos() {
    this.loading = true;
    this.apiService.Get("EspelhoPontos?ano=" + this.filtro.ano + "&mes=" + this.filtro.mes + "&geral=true").then(
      result => {
        this.listaPontos = result;
        this.loading = false;
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
    this.loading = false;
  }

  exibirDadosFuncionario(ponto) {
    if (ponto.ponto_uuid == null)
      return;
    this.loading = true;
    this.apiService.Get("Pontos?ponto_uuid=" + ponto.ponto_uuid).then(
      result => {
        this.ponto = result;
        this.loading = false;
        this.abrirModalPontoFuncionario.nativeElement.click();
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/consulta-ponto/consulta-ponto.component.ts